// Sentiments — child-theme JS entry.
//
// Each motion module is self-contained: it queries for its DOM target
// on boot and bails if absent, so importing everything here is safe on
// every route. Boot happens at DOMContentLoaded (or immediately if the
// document is already past that).

import './main.scss';

import { initHeroVideo } from './motion/hero-video.js';
import { initSectionBgVideos } from './motion/section-bg-video.js';
import { initFooterAccordion } from './motion/footer-accordion.js';
import { initFooterNewsletter } from './motion/footer-newsletter.js';
import { initSizingDrawer } from './motion/sizing-drawer.js';
import { initBuyNow } from './motion/buy-now.js';
import { initVariationUX } from './motion/variation-ux.js';
import { initNotifyMe } from './motion/notify-me.js';
import { initKnowHowPage } from './motion/know-how-page.js';
import { initAboutUsPage } from './motion/about-us-page.js';
import { initCollectionBaigaPage } from './motion/collection-baiga-page.js';
import { initWholesaleForm } from './motion/wholesale-form.js';
import { initContactForm } from './motion/contact-form.js';
import { initReturnForm } from './motion/return-form.js';
import { initAccordion } from './motion/accordion.js';
import { initHeaderScrollState } from './motion/header-scroll-state.js';
import { initPreloader } from './motion/preloader.js';
import { initScrollUnlock } from './motion/scroll-unlock.js';
import { initFbqBridge } from './motion/fbq-bridge.js';
import { initCartDrawerOnAdd } from './motion/cart-drawer-on-add.js';

const bootMicro = () => {
	// Universal — bridge the WC Interactivity-API add-to-cart block to
	// Meta Pixel's AddToCart event. Must run BEFORE initBuyNow so any
	// temporary fetch-wrap that buy-now installs nests on top of the
	// bridge's wrap (so both fire for a Buy-Now-initiated add).
	initFbqBridge();

	// Universal — undoes any body-scroll lock that plugins (Klaviyo,
	// stale WC mini-cart state, etc.) leave behind. Must run BEFORE the
	// preloader so the preloader's own intentional lock isn't immediately
	// stripped.
	initScrollUnlock();

	// Homepage preloader — owns the screen until the curtain split finishes.
	// Bails (no-op) on non-homepage routes + on second-and-later visits in
	// the same session, so it never blocks anything elsewhere.
	initPreloader();
	initHeroVideo();
	initSectionBgVideos();
	initFooterAccordion();
	initFooterNewsletter();
	// PDP modules — no-ops on non-PDP pages (bail on missing root elements).
	initSizingDrawer();
	initBuyNow();
	initVariationUX();
	// PDP feedback — open the mini-cart drawer after a successful Add-to-Cart
	// (no-op outside PDP, no-op for Buy-Now flow which redirects).
	initCartDrawerOnAdd();
	// PDP "Notify me when available" — wires the link injected by
	// variation-ux.js into a real email-capture form (AJAX → CPT +
	// Klaviyo "Notify Me Subscription" event).
	initNotifyMe();
	// /know-how/ page — lightbox + manufacturing video toggle.
	initKnowHowPage();
	// /about-us/ page — scroll reveals + letter-by-letter masthead.
	initAboutUsPage();
	// /collections/baiga/ — scroll reveals + masthead char reveal.
	initCollectionBaigaPage();
	// /wholesale-enquiry/ form — POSTs to admin-ajax via fetch.
	initWholesaleForm();
	// /contact-us/ form — POSTs to admin-ajax via fetch.
	initContactForm();
	// /returns-exchanges/ form — POSTs to admin-ajax via fetch.
	initReturnForm();
	// Universal — wires every .sentiments-accordion on the page (FAQ, PDP).
	initAccordion();
	// Universal — header transparent-while-hero / white-after-hero via IO.
	initHeaderScrollState();
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', bootMicro, { once: true });
} else {
	bootMicro();
}
